import { useState } from "react";
import { ChevronDown, Zap } from "lucide-react";
import { FAQ } from "../content";
import { usePromotion } from "../hooks/usePromotion";
import Reveal from "./Reveal";

function FaqItem({ item }) {
  const [open, setOpen] = useState(false);
  const panelId = `faq-panel-${item.id}`;
  return (
    <div
      data-testid={`faq-accordion-${item.id}`}
      className="overflow-hidden rounded-2xl border border-[#EAE6F0] bg-white transition-colors duration-200 hover:border-[#FFB3DA]"
    >
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-controls={panelId}
        className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left sm:px-7"
      >
        <span className="text-base font-bold leading-snug text-[#242344] sm:text-lg">{item.q}</span>
        <ChevronDown
          size={20}
          aria-hidden="true"
          className={`shrink-0 text-[#FF008B] transition-transform duration-300 ${open ? "rotate-180" : ""}`}
        />
      </button>
      <div id={panelId} className="acc-panel" data-open={open} role="region" aria-label={item.q}>
        <div>
          <p className="border-t border-[#EAE6F0] px-5 py-5 text-base leading-relaxed text-[#34343F] sm:px-7">
            {item.a}
          </p>
        </div>
      </div>
    </div>
  );
}

export default function Faq() {
  const { active } = usePromotion();
  const items = FAQ.filter((f) => !f.promoOnly || active);
  return (
    <section id="pytania" className="bg-[#FAF8FC] py-16 sm:py-24">
      <div className="mx-auto max-w-3xl px-4 sm:px-6">
        <Reveal>
          <h2 className="text-2xl font-bold tracking-tight text-[#242344] sm:text-3xl lg:text-4xl">
            Jak działa kurs?
          </h2>
          <p
            data-testid="faq-summary"
            className="mt-4 inline-flex flex-wrap items-center gap-x-2 gap-y-1 rounded-full border border-[#FFB3DA] bg-[#FDF4F8] px-5 py-2.5 text-sm font-bold text-[#242344]"
          >
            <Zap size={15} className="text-[#FF008B]" aria-hidden="true" />
            Kurs gotowy · Dostęp od razu po zakupie · 10 miesięcy na naukę
          </p>
        </Reveal>
        <div className="mt-8 space-y-3">
          {items.map((item) => (
            <FaqItem key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}
